import ManaSparkParticle from "../../../../physics/magic/ManaSparkParticle";
import ManaSparkParticleEffect from "../../../../physics/particle-effects/ManaSparkParticleEffect";
import ManaParticle from "../../../ManaParticle";
import NodeCategories from "../../NodeCategories";
import SimpleManaNode, { SimpleManaNodeOptions } from "../../SimpleManaNode"

export type VelocityNodeOptions = {} & SimpleManaNodeOptions

export default class VelocityNode extends SimpleManaNode {

	static nodeName = "Velocity Node"
	static nodeDesc = "Adds velocity in current direction"
	static nodeIcon = '💨'
	static category = NodeCategories.Force
	static nodeType = 'VelocityNode'


	private static BASE_VELOCITY = 25

	constructor(options: VelocityNodeOptions) {
		super({
			...options,

			cooldown: 0.1,
			cost: 1,
		})

	}

	getSymbol() {
		return VelocityNode.nodeIcon
	}

	async act(particle: ManaParticle) {

		const target = particle.target

		if (target) {
			if (target instanceof ManaSparkParticle) {
				const addedVelocity = particle.direction.clone().multiplyScalar(this.getAmp(particle) * VelocityNode.BASE_VELOCITY)

				const onVelocityPoint = addedVelocity.clone().multiplyScalar(Math.random())

				target.world.add(new ManaSparkParticleEffect({
					world: target.world,

					x: target.position.x + onVelocityPoint.x,
					y: target.position.y + onVelocityPoint.y,
				}))

				target.position.add(addedVelocity)

			} else {
				const addedVelocity = particle.direction.clone().multiplyScalar(this.getAmp(particle) * VelocityNode.BASE_VELOCITY)
				target.velocity.add(addedVelocity)
			}
		}

		return true;
	}

}